import CheckIcon from '@mui/icons-material/Check'
import {
  COACH_SPECIALTIES,
  LABEL_BY_COACH_SPECIALTY
} from 'screens/NutritionistsOrganization/NutritionistsGrid/ChangeSpecialties/ChangeSpecialties'
import { EhrCoachSpecialty } from 'types'
import { ChipGridStyled, ChipStyled } from './onboardingStyles'

export const MAX_SPECIALTIES = 5

interface ISpecialtyChips {
  value: EhrCoachSpecialty[]
  onChange: (next: EhrCoachSpecialty[]) => void
}

const Tick = () => <CheckIcon className="tick" aria-hidden="true" sx={{ fontSize: 15 }} />

export const SpecialtyChips = ({ value, onChange }: ISpecialtyChips) => {
  const toggle = (key: EhrCoachSpecialty) => {
    if (value.includes(key)) {
      onChange(value.filter((selected) => selected !== key))
    } else if (value.length < MAX_SPECIALTIES) {
      onChange([...value, key])
    }
  }

  return (
    <ChipGridStyled role="group" aria-label="Specialties">
      {COACH_SPECIALTIES.map((key) => {
        const selected = value.includes(key)
        return (
          <ChipStyled
            key={key}
            type="button"
            aria-pressed={selected}
            className={selected ? 'is-selected' : undefined}
            disabled={!selected && value.length >= MAX_SPECIALTIES}
            onClick={() => toggle(key)}
          >
            {selected && <Tick />}
            <span>{LABEL_BY_COACH_SPECIALTY[key]}</span>
          </ChipStyled>
        )
      })}
    </ChipGridStyled>
  )
}
